<template>
  <div class="menuContent">
    <div class="setBox">
      <el-aside :width="width" v-if="menuShow">
        <div shadow="never" style="border: 0" class="mainMenu">
          <div slot="header" class="clearfix">
            <el-image v-if="logo" :src="logo" lazy class="menuIcon" />
          </div>
          <el-menu :default-active="menuItemActive" @select="handleSelect" unique-opened :collapse="!asideShow">
            <!--            <el-submenu class="normalset" index="home">-->
            <!--              <template slot="title">-->
            <!--                <div @click="backHome">-->
            <!--                  <i class="whiteImg iconfont icon-shouye" />-->
            <!--                  <p>首页</p>-->
            <!--                </div>-->
            <!--              </template>-->
            <!--            </el-submenu>-->
            <template v-for="menu in menus">
              <el-submenu v-if="menu.alias === 'home'" :key="menu.id" :index="menu.alias" :class="menuItemActive === 'home' ? 'is-active2' : 'normalset'">
                <template slot="title">
                  <div @click="backHome">
                    <i class="whiteImg iconfont icon-shouye" />
                    <p>首页</p>
                  </div>
                </template>
              </el-submenu>
              <el-submenu v-else :key="menu.id" :index="menu.alias" :class="parentActiveAlia == menu.alias ? 'is-active2' : 'normalset'">
                <template slot="title">
                  <div @click="selectParent(menu, false)">
                    <i class="whiteImg iconfont icon-back-shejizhongxin" v-if="menu.alias == 'designCenter'" />
                    <i class="whiteImg iconfont icon-back-liuchengguanli" v-if="menu.alias == 'flow'" />
                    <i class="whiteImg iconfont icon-back-jichengkaifa" v-if="menu.alias == 'develop'" />
                    <i class="whiteImg iconfont icon-back-xitongguanli" v-if="menu.alias == 'system'" />
                    <i class="whiteImg iconfont icon-back-zuzhijiagou" v-if="menu.alias == 'orgStructure'" />
                    <i class="whiteImg iconfont icon-back-jifeizhongxin" v-if="menu.alias == 'billing_center'" />
                    <i class="whiteImg iconfont icon-back-yewuguize" v-if="menu.alias == 'business_rules'" />
                    <p>{{ menu.name }}</p>
                  </div>
                </template>
                <template v-if="menu.children && menu.children.length > 0 && !asideShow">
                  <template v-for="item in menu.children">
                    <el-menu-item :key="item.id" :index="item.alias" v-if="ifTenantId(item)">
                      <!-- <i class="el-icon-minus"></i> -->
                      {{ item.name }}
                    </el-menu-item>
                  </template>
                </template>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </el-aside>
      <div v-if="asideShow && submenu.length" class="childrenMenu">
        <p class="childrenTitle">{{ parentActive }}</p>
        <div
          v-for="(item, v) in submenu"
          :key="v"
          class="eachChildren"
          :class="menuItemActive == item.alias ? 'activeChildren' : 'normalChildren'"
          @click="handleSelect(item.alias)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-if="collapseItemActive" class="navbar-collapse" :class="{ 'navbar-collapse-right': !asideShow }" :style="navbarCollapseStyle" @click="leftToRight">
        <i
          class="navbar-collapse-arrow iconfont"
          :class="{
            'icon-back-shouqi': asideShow,
            'icon-back-zhankai': !asideShow
          }"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import menu from '@/api/menu.js'
import utils from '@/eco-ui-util.js'
import { mapState } from 'vuex'
import h_logo from '@/assets/img/h_logo.png'

export default {
  props: {
    menuShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      menus: (state) => {
        return state.menu.menus
      },
      currentUser: (state) => {
        return state.login.currentUser
      }
    })
  },
  watch: {
    'currentUser.tenantId': {
      handler(newValue, oldValue) {
        if (newValue) this.getLogo(newValue)
      },
      deep: true
    }
  },
  data() {
    return {
      imgSrc: '',
      collapseItemActive: '',
      menuItemActive: '',
      logo: '',
      asideShow: true,
      navbarCollapseStyle: {},
      width: '80px',
      activeTab: '',
      submenu: [],
      parentActive: '',
      parentActiveAlia: ''
    }
  },
  created() {
    this.$router.afterEach((_) => {
      this.syncUrlToMenu(false)
    })
  },
  mounted() {
    let that = this
    if (localStorage.getItem('activeAlias')) that.handleSelect(localStorage.getItem('activeAlias'), false)
  },
  methods: {
    getLogo(tenantId) {
      if (tenantId && tenantId != '-1') {
        let _this = this
        let url = '${uc}/uc/tenantManage/v1/getJson?id=' + tenantId
        _this.$http.get(url).then(
          (resp) => {
            if (resp.data) {
              let tenantManage = resp.data
              if (tenantManage.manageLogo) {
                let manageLogo = JSON.parse(tenantManage.manageLogo)
                if (manageLogo && manageLogo.length > 0) {
                  _this.logo = window.context.portal + '/system/file/v1/downloadFile?fileId=' + manageLogo[0].id
                  return
                }
              }
            }
            _this.logo = h_logo
          },
          (error) => {
            _this.logo = h_logo
            reject(error)
          }
        )
      } else {
        this.logo = h_logo
      }
    },
    ifTenantId(item) {
      return this.currentUser.tenantId === '-1' ? item.alias !== 'billing_center_inner' : true
    },
    AllToRight() {
      this.asideShow = true
      this.width = '80px'
    },
    leftToRight() {
      this.asideShow = !this.asideShow
      if (this.asideShow) {
        if (this.collapseItemActive) {
          const index = this.menus.find((e) => e.alias == this.collapseItemActive)
          if (index) this.submenu = index.children
          this.parentActiveAlia = this.collapseItemActive
        }
      }
      this.$store.dispatch('menu/getHasLeft', !!this.submenu.length)
    },
    // 同步当前url地址到目录菜单中，选中对应的目录菜单
    syncUrlToMenu: function (flag = true) {
      let routePath = this.$route.path
      if (routePath) {
        routePath = routePath.replace('/', '')
        this.handleSelect(routePath, flag)
      }
    },
    selectParent(item, flag = true) {
      if (!item) return
      localStorage.removeItem('companyNameHasLeft')
      this.parentActive = item.name
      this.parentActiveAlia = item.alias
      this.collapseItemActive = this.parentActiveAlia
      if (this.asideShow) {
        const index = this.menus.find((e) => e.alias == item.alias)
        if (index && index.children && index.children.length) {
          this.submenu = index.children
          // this.$router.push({ name: index.children[0].alias })
          this.handleSelect(index.children[0].alias)
        }
      } else {
        if (!flag) {
          this.menuItemActive = ''
          this.$forceUpdate()
        }
        this.submenu = []
      }
      this.$store.dispatch('menu/getHasLeft', !!this.submenu.length)
    },
    backHome() {
      this.$router.push({ path: '/home' })
    },
    // 判断是否拥有当前url地址的权限
    isHasCurrentUrlRight: function () {
      let routePath = this.$route.path
      if (routePath) {
        let hasRight = false
        if (!this.menus || this.menus.length < 1) {
          return hasRight
        }
        let tempMenu = JSON.parse(JSON.stringify(this.menus))
        let listMenu = utils.nest2tile(tempMenu, '', true)
        let ruterArr = routePath.split('/')
        let lastRuter = ruterArr[ruterArr.length - 1]
        listMenu.forEach((menu) => {
          if (lastRuter.indexOf(menu.alias) > -1) {
            hasRight = true
            return
          }
        })
        return hasRight
      }
    },
    handleSelect: function (alias, flag = true) {
      if (!alias) return
      localStorage.setItem('activeAlias', alias)
      //判断字符串开头是否包含“/”
      if (alias.substr(0, 1) == '/') {
        alias = alias.replace('/', '')
      }
      if (alias != 'tenant') {
        this.$store.dispatch('tenant/actionTenantId', null)
      }
      if (alias == 'home') {
        this.submenu = []
        this.parentActive = ''
        this.parentActiveAlia = ''
        this.collapseItemActive = ''
        this.menuItemActive = alias
      }
      let _this = this
      menu.getMenuByAlias(alias, (m) => {
        m && _this.$emit('menuChange', m)
        if (m && m.parent) {
          _this.collapseItemActive = m.parent.alias
          _this.parentActiveAlia = m.parent.alias
          _this.menuItemActive = m.alias
          _this.parentActive = m.parent.name
          _this.activeTab = m.activeTab
          // const index = _this.menus.find((e) => e.alias == m.parent.alias)
          // _this.selectParent(index)
        }
      })
      if (flag) this.$router.push({ name: alias })
      let clickMenu = this.menus.find((m) => m.alias === _this.activeTab)
      if (!clickMenu) {
        clickMenu = utils.findNode(this.menus, (node) => {
          return node.alias === _this.activeTab
        })
      }
      if (clickMenu) {
        this.setDashboard(clickMenu.dashboard)
      }
      this.$forceUpdate()
    },
    setDashboard(dashboardUrl) {
      this.$store.dispatch('menu/getCurrentDashboard', dashboardUrl)
    }
  }
}
</script>
<style lang="stylus" scoped>
.whiteImg, .blueImg {
  width: 16px;
  height: 16px;
}

.el-main {
  padding: 0px;
  margin: 0;
  background-color: #fff;
}

.el-aside {
  background-color: #2C3B66;
  box-shadow: -2px 0px 6px #000;
  height: calc(100vh);
  position: relative;
}

.div {
  background-color: transparent;
}

.el-card >>> .el-card__header {
  border-bottom: 1px solid #fff;
  color: #fff;
  padding: 20px 10px 5px;
}

.el-card >>> .el-card__body {
  padding: 0;
  padding-left: 12px;
}

.el-menu-item {
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.menu-ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.menu-ul > li {
  padding: 10px 0 10px 0;
  height: 30px;
  line-height: 30px;
  list-style: none;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 1px solid #dfdfdf;
}

.menu-ul > li:last-child {
  border-bottom: 0;
}

.menu-ul > li > a {
  color: #000;
  padding: 2px 5px 2px 17px;
  border-left: 2px solid transparent;
  text-decoration: none;
}

.el-menu--popup .el-menu-item {
  color: #666;
}

.menu-ul > li > a.router-link-active {
  border-left: 2px solid #2761ff;
  color: #172E71;
  background: #fff;
}

.el-menu, >>> .el-menu {
  background-color: transparent;
  border-right: none;
}

.el-submenu .el-menu-item {
  padding-left: 40px !important;
  color: #fff;
}

.el-submenu .el-menu--popup .el-menu-item {
  color: #666;
}

.menuIcon {
  max-width: 60px;
  cursor: pointer;
  max-height: 60px;
}
</style>
<style lang="scss">
.menuContent {
  position: relative;
  .mainMenu {
    width: 80px;
  }
  .el-submenu__icon-arrow {
    display: none;
  }
  .navbar-collapse {
    position: absolute;
    top: 32px;
    margin-top: -33px;
    right: -50px;
    display: flex;
    text-align: center;
    align-items: center;
    cursor: pointer;
    width: 20px;
  }

  .navbar-collapse.navbar-collapse-right {
    // top: 40%;
  }
  .navbar-collapse:hover .navbar-collapse-arrow {
    color: #333333;
  }
  .clearfix {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .navbar-collapse-arrow {
    position: relative;
    margin-top: 14px;
    right: 15px;
    font-size: 16px;
    color: #333;
  }
  .navbar-collapse-bg {
    -webkit-transition: all 0.12s ease;
    height: 50px;
    border-bottom: 8px solid transparent;
    border-right: none;
    border-left: 12px solid #2c3b66;
    border-top: 8px solid transparent;
    opacity: 0.9;
  }
  .el-card .el-card__body {
    padding: 0 !important;
  }
  .el-submenu {
    .el-submenu__title {
      color: #fff !important;
      height: 80px !important;
      width: 80px !important;
      padding: 0 !important;
      line-height: 20px;
      div {
        height: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        p {
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
          margin: 0;
        }
      }
    }
  }
  .el-menu--collapse {
    width: 80px;
  }

  .el-submenu__title i {
    color: #fff;
    font-size: 18px;
    margin-bottom: 12px;
  }
  .el-menu-item:hover {
    background: transparent !important;
  }
  .el-submenu__title:hover {
    background: #155bd4 !important;
  }
  .el-submenu {
    width: 80px;
    height: 80px;
  }
  .el-submenu .el-menu-item {
    line-height: 50px;
    height: 50px;
  }

  .el-submenu .el-submenu .el-menu-item {
    line-height: 30px !important;
    height: 30px !important;
  }
  // .el-submenu .el-submenu__title {
  //   line-height: 50px;
  //   height: 50px;
  // }
  .el-menu-item:hover.is-active {
    background: #fff !important;
  }
  .is-active2 {
    background: #155bd4 !important;
  }
  .normalset {
    background: unset !important;
  }
  .is-active {
    background: #155bd4 !important;
  }
  .activeChildren {
    height: 32px !important;
    background: rgba(21, 91, 212, 0.1) !important;
    border-radius: 4px !important;
  }
  .normalChildren {
    border-radius: 4px;
    height: 32px;
    background: #fff;
  }
  .setBox {
    display: flex;
  }
  .childrenMenu {
    width: 135px;
    padding: 0 10px;
    height: 100vh;
    background: #ffffff;
    border-right: 1px solid #f2f3f5;
    overflow-y: auto;
    .eachChildren {
      padding: 0 10px;
      height: 32px;
      background: #fff;
      // background: rgba(21, 91, 212, 0.1);
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      margin: 4px 0;
      cursor: pointer;
    }
    .childrenTitle {
      margin: 0 10px;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 59px;
      border-bottom: 1px solid #e0e0e0;
    }
  }
}
.el-menu--vertical {
  .el-menu-item {
    color: #333333;
    background: #fff;
  }
  .el-menu-item.is-active {
    color: #333333;
    background: rgba(21, 91, 212, 0.1);
  }
  .el-menu-item:hover {
    color: #333333;
    background: rgba(21, 91, 212, 0.1);
  }
}
</style>
